const { get } = require('lodash/fp');
const { useIntl } = require('react-intl');
const Bugsnag = require('@bugsnag/js');
const BUGSNAG_CONSTANTS = require('../constants/BUGSNAG_CONSTANTS');

const LanguageConverter = (text, value) => {
  const intl = useIntl();
  const key = get(text, intl.messages);
  if (!key) {
    Bugsnag.notify(new Error(), e => {
      e.severity = BUGSNAG_CONSTANTS.SEVERITY.WARNING;
      e.context = `Missing i18n key: ${text}`;
    });
  }
  return intl.formatMessage({ id: text }, { value });
};

module.exports = LanguageConverter;
